import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

type BannerTitleProps = {
    children: string;
};

const bodyCss = css({
    margin: 0,
    fontSize: token("space.200"),
    lineHeight: token("space.300"),
    fontWeight: "normal"
});

const BannerTitle = ({ children }: BannerTitleProps) => {
    return <h3 css={bodyCss}>{children}</h3>;
};
export default BannerTitle;
